import QrReader from 'react-qr-reader';
import { useEffect, FC } from 'react';
import { useLocation, useHistory, Redirect } from "react-router-dom";

import * as API from 'api';
import * as Meta from 'meta';
import * as Type from "type.d";

import { ROUTE } from 'route';
import { Footer, Header } from 'components';
import { currentTime, isBuilding, setResult, isAgreePrivate, deviceType } from 'utils';
// import { BeforeEventPage } from 'pages/BeforeEventPage';

let isScanned: boolean = false;

// 將掃到的qrcode打給後端並要是否中獎資料
const postTicket = (qrcode: string, cb: any = () => {}) => {
  fetch(API.ticket(), {
    method: 'POST',
    headers: {'content-type': 'application/json'},
    body: JSON.stringify({
      qrcode,
      date: currentTime(),
      ishara: API.getToken(),
    })
  }).then(res => {
    return res.json();
  }).then(cb);
};

export const ScanPage: FC = () => {

  const history = useHistory();
  const location = useLocation();
  const url = new window.URLSearchParams(location.search.slice(1));
  const qrcode = url.get('qrcode');

  if(!isAgreePrivate()) {
    const search = url.get('qrcode') ? `?qrcode=${url.get('qrcode')}`: '';
    return <Redirect to={`${ROUTE.PRIVATE}/${search}`} />;
  }

  const scanResult = (json: Type.ITicketJson) => {
    if(json.errors) {
      isScanned = false;
      return history.push(ROUTE.SCANNED);
    }
    setResult(json.result);
    isScanned = false;
    history.push(ROUTE.ANIMA);
  };

  useEffect(() => {
    if(!qrcode || !API.getToken()) return;
    postTicket(qrcode, scanResult);
  }, [qrcode]);

  const handleScan = (data: string) => {
    // 掃過後將相機關閉
    if (!isScanned && data) {
      isScanned = true;
      const url = new URL(data);
      const qrcode = url.searchParams.get('qrcode');
      postTicket(qrcode, scanResult);
    }
  };

  useEffect(() => {
    const fakeQRCode = localStorage.getItem('FAKE_QRCODE');
    if(navigator.userAgent.includes('cypress')) handleScan(`https://fake.com/scan?qrcode=${fakeQRCode}`);
  }, []);

  const handleError = (err: string) => {
    console.error(err);
  };

  if(deviceType() === 'desktop') return <Redirect to={`${ROUTE.PCSTEP}`} />;

  if(qrcode) return null;

  return (
    <div className="wrapper">
      {Meta.loadCSS(['login', 'notice'])}
      {Meta.loadJS(['main-0625'])}
      {Meta.ga("掃描相機頁")}
      <Header />
      <div className="main">
        <section className="login inner">
          <div className="login_iscan"><img src="/resources/html/images/login/scan.png" /></div>
          <div className="login_scantext">請掃描罐身QRcode貼紙</div>
          <div className="login_scan">
            <div className="login_scan_lt" />
            <div className="login_scan_rt" />
            <div className="login_scan_lb" />
            <div className="login_scan_rb" />
            {!isBuilding() &&
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
          />
            }
          </div>
        </section>
        <div className="fwave fw1 ml"><img src="/resources/html/images/login/wave01.png" /></div>
        <div className="fwave fw2 mr"><img src="/resources/html/images/login/wave02.png" /></div>
        <div className="fwave fw3 ml"><img src="/resources/html/images/login/wave03.png" /></div>
        <div className="fwave fw4 mr"><img src="/resources/html/images/login/wave04.png" /></div>
      </div>
      <Footer />
    </div>
  );
};
